import { render, staticRenderFns } from "./phoneHeader.vue?vue&type=template&id=0bbbed63&scoped=true&"
import script from "./phoneHeader.vue?vue&type=script&lang=js&"
export * from "./phoneHeader.vue?vue&type=script&lang=js&"
import style0 from "./phoneHeader.vue?vue&type=style&index=0&id=0bbbed63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbbed63",
  null
  
)

export default component.exports